/* POINTURE STOCK FILTER (2026-09-14, reecrit 2026-09-25) -- quand le filtre
   natif Search & Discovery "Pointure" (filter.v.option.pointure) est applique
   sur une page collection, Shopify ne verifie que l'EXISTENCE d'une variante a
   cette pointure, pas son STOCK reel -- un produit peut donc rester affiche
   alors que la pointure demandee y est en rupture (retour utilisateur
   2026-09-25 : "pointure 22 filtree mais les fiches affichent 24").

   2026-09-25 -- meme mecanisme que shoopom.fr (assets/size-quick-filter.js) :
   sections/main-collection.liquid calcule deja un attribut data-sizes par
   carte ("18|19|20|..."), base UNIQUEMENT sur les variantes reellement
   disponibles (variant.available) -- ce fichier l'exploite desormais pour
   (1) masquer cote client toute carte dont la pointure demandee n'est pas
   dans data-sizes (le filtre natif l'a laissee passer a tort), (2) afficher
   un bandeau "Pointure X -- N produit(s) disponible(s)" avec un vrai compte,
   et (3) ne fixer le swatch visuel que sur les cartes ou cette pointure est
   reellement disponible (jamais sur une carte masquee). Auparavant ce fichier
   ne faisait que (3), d'ou le decalage rapporte (le swatch retombait sur son
   defaut sans que rien ne previenne l'utilisateur que ce produit precis
   n'avait pas la pointure demandee). */
(function () {
  "use strict";

  var PARAM = "filter.v.option.pointure";

  function getRequestedSizes() {
    return new URLSearchParams(window.location.search).getAll(PARAM).filter(Boolean);
  }

  function simulateRealClick(el) {
    ["pointerdown", "mousedown", "pointerup", "mouseup", "click"].forEach(function (type) {
      var ev = new MouseEvent(type, { bubbles: true, cancelable: true, view: window });
      el.dispatchEvent(ev);
    });
  }

  function findSizeSwatch(card, size) {
    var items = card.querySelectorAll(".swatch-view-item[orig-value]");
    var target = null;
    items.forEach(function (li) {
      if (target) return;
      if (li.classList.contains("swatch-item-unavailable")) return;
      if ((li.getAttribute("orig-value") || "") === size) target = li;
    });
    return target;
  }

  function forceSwatch(card, size, attempt) {
    attempt = attempt || 0;
    if (card.getAttribute("data-pointure-fixed") === size) return;

    var target = findSizeSwatch(card, size);
    if (!target) {
      if (attempt < 8) setTimeout(function () { forceSwatch(card, size, attempt + 1); }, 400);
      return;
    }
    if (target.getAttribute("aria-checked") === "true") {
      card.setAttribute("data-pointure-fixed", size);
      return;
    }
    simulateRealClick(target.querySelector(".swatch-button") || target);
    card.setAttribute("data-pointure-fixed", size);
  }

  function updateBanner(sizes, visibleCount) {
    var banner = document.getElementById("PointureStockBanner");
    if (sizes.length) {
      if (!banner) {
        banner = document.createElement("div");
        banner.id = "PointureStockBanner";
        banner.className = "pointure-stock-banner";
        var grid = document.querySelector(".product-grid");
        if (grid && grid.parentNode) grid.parentNode.insertBefore(banner, grid);
      }
      var label = sizes.join(" / ");
      var newHtml = "Pointure " + label + " — " + visibleCount + " produit(s) disponible(s) <a href=\"" + window.location.pathname + "\">Retirer le filtre</a>";
      if (banner.innerHTML !== newHtml) banner.innerHTML = newHtml;
      banner.style.display = "";
    } else if (banner) {
      banner.style.display = "none";
    }
  }

  function run() {
    var sizes = getRequestedSizes();
    var cards = document.querySelectorAll(".product-grid__size-wrap");
    if (!cards.length) return;

    if (!sizes.length) {
      cards.forEach(function (card) {
        if (card.style.display !== "") card.style.display = "";
      });
      updateBanner(sizes, 0);
      return;
    }

    var visibleCount = 0;
    cards.forEach(function (card) {
      var cardSizes = (card.getAttribute("data-sizes") || "").split("|").filter(Boolean);
      var matched = null;
      for (var i = 0; i < sizes.length; i++) {
        if (cardSizes.indexOf(sizes[i]) !== -1) { matched = sizes[i]; break; }
      }
      var newDisplay = matched ? "" : "none";
      if (card.style.display !== newDisplay) card.style.display = newDisplay;
      if (matched) {
        visibleCount++;
        forceSwatch(card, matched);
      }
    });

    updateBanner(sizes, visibleCount);
  }

  document.addEventListener("DOMContentLoaded", function () {
    run();

    // Search & Discovery remplace .filters-adjacent (grille comprise) a
    // chaque clic sur un filtre classique (ajax) -- nouvelles cartes, le
    // bandeau lui-meme est recree si absent (voir updateBanner). Meme garde
    // deconnexion/reconnexion que le reste du theme pour eviter qu'un clic
    // simule ici (simulateRealClick) ne redeclenche cette meme callback en
    // boucle.
    var gridAdjacent = document.querySelector(".filters-adjacent") || document.querySelector(".product-grid");
    if (gridAdjacent) {
      var observer = new MutationObserver(function () {
        observer.disconnect();
        run();
        observer.observe(gridAdjacent, { childList: true, subtree: true });
      });
      observer.observe(gridAdjacent, { childList: true, subtree: true });
    }
  });
})();
